import { render } from "./404.vue?vue&type=template&id=3c4b1416"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=3c4b1416&lang=css"
script.render = render

export default script